import React from "react";
import { Box, Typography, InputBase } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const SearchIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="11" cy="11" r="8"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
);

const TABS = [
  
  { value: "at-pmo",   labelFn: (s) => `At PMO (${s?.atPmo ?? 0})`   },
  { value: "at-scg",   labelFn: (s) => `At SCG (${s?.atScg ?? 0})`   },
  { value: "rejected", labelFn: (s) => `Rejected (${s?.rejected ?? 0})`, color: "#c84040" },
];

const FilterTabs = ({ activeFilter, onFilterChange, summary, search, onSearchChange }) => {
  const theme = useTheme();
  const t     = theme.custom;

  return (
    <Box sx={{
      display: "flex", alignItems: "center",
      justifyContent: "space-between",
      mb: "16px", gap: "10px", flexWrap: "wrap",
    }}>

      {/* Tab pills */}
      <Box sx={{
        display: "flex", gap: "4px",
        background: t.surface2,
        border: `1px solid ${t.border2}`,
        borderRadius: "6px", padding: "4px",
      }}>
        {TABS.map((tab) => {
          const isActive = activeFilter === tab.value;
          const color    = tab.color || (isActive ? t.accent : t.text2);

          return (
            <Box
              key={tab.value}
              onClick={() => onFilterChange(tab.value)}
              sx={{
                padding: "6px 14px", borderRadius: "4px",
                cursor: "pointer", transition: "all 0.15s",
                background: isActive ? t.surface : "transparent",
                boxShadow: isActive
                  ? "0 1px 4px rgba(0,0,0,0.1)"
                  : "none",
              }}
            >
              <Typography sx={{
                fontFamily: "'Inter', sans-serif",
                fontSize: "12px",
                fontWeight: isActive ? 600 : 400,
                color: tab.color
                  ? tab.color
                  : isActive ? t.accent : t.text2,
                whiteSpace: "nowrap",
                transition: "color 0.15s",
              }}>
                {tab.labelFn(summary)}
              </Typography>
            </Box>
          );
        })}
      </Box>

      {/* Search */}
      <Box sx={{
        display: "flex", alignItems: "center", gap: "8px",
        background: t.surface2, border: `1px solid ${t.border2}`,
        borderRadius: "4px", padding: "6px 12px", width: "240px",
      }}>
        <Box sx={{ color: t.text3 }}><SearchIcon /></Box>
        <InputBase
          placeholder="Search..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          sx={{
            flex: 1, fontFamily: "'Inter', sans-serif",
            fontSize: "12px", color: t.text,
          }}
        />
      </Box>
    </Box>
  );
};

export default FilterTabs;